// Preset and legacy Custom + Funding both use the persisted badge label.
export function isFundingDevelopmentBadge(value: unknown): boolean {
    return typeof value === 'string' && value.trim().toLowerCase() === 'funding';
}
